import { render, staticRenderFns } from "./StoreOrderDetail.vue?vue&type=template&id=5ac8461a&scoped=true"
import script from "./StoreOrderDetail.vue?vue&type=script&lang=js"
export * from "./StoreOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./StoreOrderDetail.vue?vue&type=style&index=0&id=5ac8461a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac8461a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ac8461a')) {
      api.createRecord('5ac8461a', component.options)
    } else {
      api.reload('5ac8461a', component.options)
    }
    module.hot.accept("./StoreOrderDetail.vue?vue&type=template&id=5ac8461a&scoped=true", function () {
      api.rerender('5ac8461a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/DeliveryEffiRider/StoreOrderDetail.vue"
export default component.exports